import "bootstrap/dist/css/bootstrap.min.css";

const Footer = () => {
  return (
    <footer className="modern-footer text-white mt-auto" style={{
      background: "#1A365D",
      borderTop: "3px solid #213F78",
      position: "relative",
      overflow: "hidden"
    }}>
      {/* Background Pattern */}
      <div className="position-absolute w-100 h-100" style={{
        backgroundImage: "radial-gradient(circle at 25% 25%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 75% 75%, rgba(255,255,255,0.1) 0%, transparent 50%)",
        zIndex: 1
      }}></div>
      
      <div className="container-fluid position-relative" style={{ zIndex: 2 }}>
        {/* Main Footer Content */}
        <div className="row g-4 py-5">
          {/* Brand Section */}
          <div className="col-lg-4 col-md-6">
            <div className="footer-brand">
              <div className="d-flex align-items-center mb-3">
                <img src="/Logo.png" alt="Logo" height="50" className="me-3" style={{
                  filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.2))"
                }} />
                <h5 className="fw-bold mb-0 text-white">🏛️ जैन समग्र पोर्टल</h5>
              </div>
              <p className="mb-3 opacity-90" style={{ lineHeight: "1.6", color: "#FFFFFF" }}>
                जैन समुदाय को सशक्त बनाने के लिए एक आधुनिक डिजिटल मंच। 
                हमारा उद्देश्य सभी जैन परिवारों को एक साथ जोड़ना है।
              </p>
              <div className="social-links">
                <span className="badge me-2 px-3 py-2" style={{
                  background: "rgba(255,255,255,0.2)",
                  color: "#FFFFFF",
                  border: "1px solid rgba(255,255,255,0.3)"
                }}>
                  📧 Connect
                </span>
                <span className="badge me-2 px-3 py-2" style={{
                  background: "rgba(255,255,255,0.2)",
                  color: "#FFFFFF",
                  border: "1px solid rgba(255,255,255,0.3)"
                }}>
                  📱 Follow
                </span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-6">
            <h6 className="fw-bold mb-3" style={{ color: "#FFFFFF" }}>🔗 Quick Links</h6>
            <ul className="list-unstyled footer-links">
              <li className="mb-2">
                <a href="/" className="text-white text-decoration-none d-flex align-items-center footer-link">
                  <span className="me-2">🏠</span> Home
                </a>
              </li>
              <li className="mb-2">
                <a href="/registration" className="text-white text-decoration-none d-flex align-items-center footer-link">
                  <span className="me-2">📝</span> Register Family
                </a>
              </li>
              <li className="mb-2">
                <a href="/search" className="text-white text-decoration-none d-flex align-items-center footer-link">
                  <span className="me-2">🔍</span> Search
                </a>
              </li>
              <li className="mb-2">
                <a href="/parivar-card" className="text-white text-decoration-none d-flex align-items-center footer-link">
                  <span className="me-2">💳</span> Family Card
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="col-lg-3 col-md-6">
            <h6 className="fw-bold mb-3" style={{ color: "#FFFFFF" }}>🛠️ Services</h6>
            <ul className="list-unstyled footer-links">
              <li className="mb-2">
                <span className="text-white d-flex align-items-center">
                  <span className="me-2">👨👩👧👦</span> Family Registration
                </span>
              </li>
              <li className="mb-2">
                <span className="text-white d-flex align-items-center">
                  <span className="me-2">👤</span> Member Management
                </span>
              </li>
              <li className="mb-2">
                <span className="text-white d-flex align-items-center">
                  <span className="me-2">💳</span> Digital ID Cards
                </span>
              </li>
              <li className="mb-2">
                <span className="text-white d-flex align-items-center">
                  <span className="me-2">📊</span> Community Analytics
                </span>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-lg-3 col-md-6">
            <h6 className="fw-bold mb-3" style={{ color: "#FFFFFF" }}>📞 Contact Info</h6>
            <div className="contact-info">
              <div className="mb-3 p-3 rounded contact-card" style={{
                background: "rgba(255,255,255,0.15)",
                backdropFilter: "blur(5px)",
                border: "1px solid rgba(255,255,255,0.2)"
              }}>
                <p className="mb-1 fw-semibold text-white">📧 Email Support</p>
                <small className="opacity-90 text-white">jainsamagraportal@gmail.com</small>
              </div>
              
              <div className="mb-3 p-3 rounded contact-card" style={{
                background: "rgba(255,255,255,0.15)",
                backdropFilter: "blur(5px)",
                border: "1px solid rgba(255,255,255,0.2)"
              }}>
                <p className="mb-1 fw-semibold text-white">📱 Phone Support</p>
                <small className="opacity-90 text-white">+91 94250 06497</small>
              </div>
              
              <div className="p-3 rounded contact-card" style={{
                background: "rgba(255,255,255,0.15)",
                backdropFilter: "blur(5px)",
                border: "1px solid rgba(255,255,255,0.2)"
              }}>
                <p className="mb-1 fw-semibold text-white">🕒 Support Hours</p>
                <small className="opacity-90 text-white">Mon-Fri: 9AM-6PM</small>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <hr className="border-white-50 my-4" style={{ opacity: 0.3 }} />

        {/* Bottom Footer */}
        <div className="row align-items-center py-3">
          <div className="col-md-6">
            <div className="d-flex align-items-center">
              <span className="me-3">🏛️</span>
              <div>
                <p className="mb-0 fw-semibold text-white">Jain Samagra Portal</p>
                <small className="opacity-75 text-white">Empowering Jain Community Digitally</small>
              </div>
            </div>
          </div>
          
          <div className="col-md-6 text-md-end mt-3 mt-md-0">
            <div className="footer-badges">
              <span className="badge me-2 px-3 py-2 footer-badge" style={{
                background: "rgba(255,255,255,0.2)",
                color: "#FFFFFF",
                border: "1px solid rgba(255,255,255,0.3)"
              }}>
                🔒 Secure
              </span>
              <span className="badge me-2 px-3 py-2 footer-badge" style={{
                background: "rgba(255,255,255,0.2)",
                color: "#FFFFFF",
                border: "1px solid rgba(255,255,255,0.3)"
              }}>
                ⚡ Fast
              </span>
              <span className="badge px-3 py-2 footer-badge" style={{
                background: "rgba(255,255,255,0.2)",
                color: "#FFFFFF",
                border: "1px solid rgba(255,255,255,0.3)"
              }}>
                🌟 Trusted
              </span>
            </div>
            <div className="mt-2">
              <small className="opacity-75 text-white">
                © 2026 <strong>Jain Samagra Portal</strong>. All rights reserved.
              </small>
            </div>
            <div className="mt-1">
              <small className="opacity-60 text-white" style={{ fontSize: "0.7rem" }}>
                Created by SochCreatives | Contact: 8602138210
              </small>
            </div>
          </div>
        </div>
      </div>
      
      {/* Enhanced Footer Styles */}
      <style>{`
        .footer-link {
          transition: all 0.3s ease;
          opacity: 0.9;
          padding: 4px 0;
        }
        
        .footer-link:hover {
          opacity: 1;
          transform: translateX(5px);
          color: #F3F4F6 !important;
          text-shadow: 1px 1px 2px rgba(0,0,0,0.2);
        }
        
        .contact-card {
          transition: all 0.3s ease;
        }
        
        .contact-card:hover {
          background: rgba(255,255,255,0.25) !important;
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(0,0,0,0.1);
        }
        
        .footer-badge {
          transition: all 0.3s ease;
        }
        
        .footer-badge:hover {
          background: rgba(255,255,255,0.3) !important;
          transform: scale(1.05);
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }
        
        .footer-brand img {
          transition: transform 0.3s ease;
        }
        
        .footer-brand img:hover {
          transform: scale(1.05);
        }
        
        @media (max-width: 768px) {
          .footer-brand img {
            height: 40px !important;
          }
          
          .contact-card {
            margin-bottom: 1rem !important;
          }
          
          .footer-badges {
            text-align: center !important;
          }
          
          .footer-badges .badge {
            margin: 2px !important;
          }
          
          .col-md-6 {
            text-align: center !important;
          }
        }
        
        @media (max-width: 576px) {
          .footer-brand h5 {
            font-size: 1rem !important;
          }
          
          .footer-brand p {
            font-size: 0.9rem !important;
          }
          
          .contact-info {
            margin-top: 1rem;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;